import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const HubDbRowsQuery = registerQuery({
  fieldName: 'hubDbRows',
  fetcher: ({
    hubDbTableId
  }) => http.get(`hubdb/api/v2/tables/${hubDbTableId}/rows`)
});
const useHubDbRows = ({
  hubDbTableId,
  hubDbRowId
}) => {
  var _data$hubDbRows;
  const {
    data,
    loading,
    error
  } = useQuery(HubDbRowsQuery, {
    variables: {
      hubDbTableId: hubDbTableId
    },
    skip: !hubDbTableId
  });
  const hubDbRow = hubDbRowId ? data === null || data === void 0 || (_data$hubDbRows = data.hubDbRows) === null || _data$hubDbRows === void 0 ? void 0 : _data$hubDbRows.objects.find(row => row.id === hubDbRowId) : undefined;
  return useMemo(() => ({
    hubDbRow,
    hubDbRows: data === null || data === void 0 ? void 0 : data.hubDbRows,
    hubDbRowsRequestLoading: loading,
    hubDbRowsRequestError: error
  }), [data, error, loading, hubDbRow]);
};
export default useHubDbRows;